import { Wrapper } from '@ahmdigital/ui';

import CommonQuestionsSection from '../../../../../components/sections/common-questions-section';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';
import styles from './styles.module.sass';
import type { QuestionsList } from '../../../../../types/__codegen__/sanity/graphql';

type OtherSavingsProps = {
  questions?: QuestionsList | null;
};

type LegacyAnalyticsLabels = Record<string, string | undefined>;

const LEGACY_ANALYTICS_LABELS: LegacyAnalyticsLabels = {
  'Do I need private health insurance for tax purposes?': undefined,
  'Lifetime Health Cover (LHC) loading': 'lhc',
  'The Australian Government Rebate (AGR) on private health insurance': 'agr',
  'Youth Discount': 'youth-discount',
};

const OtherSavings = ({ questions }: OtherSavingsProps) => {
  const items = getFormattedQuestionForAccordion(questions?.questions).map((item) => {
    const hasLegacyAnalyticsLabel = Object.prototype.hasOwnProperty.call(LEGACY_ANALYTICS_LABELS, item.title);

    return {
      ...item,
      analyticsLabel: hasLegacyAnalyticsLabel ? LEGACY_ANALYTICS_LABELS[item.title] : item.analyticsLabel,
    };
  });

  if (!items.length) {
    return null;
  }

  return (
    <Wrapper className={styles.wrapper}>
      <CommonQuestionsSection
        accordionId="tax-other-savings"
        questions={items}
        title={questions?.title ?? 'Other ways you could save with health insurance'}
      />
    </Wrapper>
  );
};

export default OtherSavings;
